import { EditLocalV1EventPage } from "./EditLocalV1EventPage";

export default EditLocalV1EventPage;
